module.exports = __webpack_public_path__ + "static/media/kabuki.ac03409b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stay/kabuki.jpg
// module id = 579
// module chunks = 0